module.exports = __webpack_public_path__ + "static/img/9.4f9d394.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/9.jpg
// module id = U2Te
// module chunks = 0